import {useState} from 'react';

import {Grid, ToggleButton, ToggleButtonGroup, Typography} from '@mui/material';

import {TabProps} from './CompanyInfoToggle';
import {styles} from './CompanyInfoToggle.style';
import {PageSection} from '../../../../../components/PageSection/PageSection';
import {orangeColors} from '../../../../../layouts/theme/designSystem';

interface Props {
  leftTabContent: TabProps;
  rightTabContent: TabProps;
  elementRef: (node: HTMLDivElement | null) => void;
}
export const DesktopDisplay = ({leftTabContent, rightTabContent, elementRef}: Props) => {
  const [activeTab, setActiveTab] = useState<string>('job');

  const onClickHandler = (e: any) => {
    setActiveTab(e.currentTarget.value);
  };

  const getActiveStyles = (tab: string | number) => {
    if (tab === activeTab) {
      return {
        backgroundColor: `${'white'} !important`,
        ...styles.button,
      };
    }
    return {
      ...styles.button,
      backgroundColor: `${orangeColors[3]}`,
    };
  };

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <ToggleButtonGroup sx={styles.buttonContainer} fullWidth exclusive value={activeTab}>
            <ToggleButton value={leftTabContent.id} onClick={onClickHandler} sx={getActiveStyles(leftTabContent.id)}>
              <Typography sx={{paddingLeft: '32px'}}>{leftTabContent.tab}</Typography>
            </ToggleButton>
            <ToggleButton value={rightTabContent.id} onClick={onClickHandler} sx={getActiveStyles(rightTabContent.id)}>
              <Typography sx={{paddingLeft: '32px'}}>{rightTabContent.tab}</Typography>
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid>
      <PageSection selfRef={elementRef} bgColor={'white'}>
        {leftTabContent.id === activeTab ? leftTabContent.component : rightTabContent.component}
      </PageSection>
    </>
  );
};
